import mongoose, { Schema } from 'mongoose';
import localizedField, { ILocalizedText } from './localized-text';

const validCategories = ['Accommodation', 'Activity', 'Food', 'Transport'];

export interface ICategory {
  icon?: string;
  names: ILocalizedText;
}

export interface ICategoryDocument extends mongoose.Document, ICategory {
  _id: never;
}

const category = new Schema(
  {
    icon: {
      type: String,
    },
    names: {
      type: localizedField,
      required: true,
      validate: {
        validator(names: ILocalizedText) {
          return validCategories.includes(names.en);
        },
        // @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/35860
        message: (props: any) =>
          `${props.value} is not a valid category! It has to be one of ${validCategories.join(
            ', ',
          )}`,
      },
    },
  },
  { _id: false },
);

export default category;
